module.exports = __webpack_public_path__ + "assets/img/魔法小侦探.38be90dc.png";